export const filterNullableElements = <T>(
  elementList: (T | undefined | null)[]
): T[] =>
  elementList.filter(
    element => element !== undefined && element !== null
  ) as T[]
